module.exports = __webpack_public_path__ + "static/img/download.cd5cb1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/download.png
// module id = 908
// module chunks = 1